import { render, staticRenderFns } from "./productSatellite.vue?vue&type=template&id=1e434074&scoped=true&"
import script from "./productSatellite.vue?vue&type=script&lang=js&"
export * from "./productSatellite.vue?vue&type=script&lang=js&"
import style0 from "./productSatellite.vue?vue&type=style&index=0&id=1e434074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e434074",
  null
  
)

export default component.exports